import styled from 'styled-components/macro';
import { spacing01, spacing03 } from '../../../styling/spacing';
import { fontSize06 } from '../../../styling/fonts';

export const SidebarTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  border: 1px solid black;

  th,
  td {
    padding-left: ${spacing01};
    border-bottom: 1px solid black;
    text-transform: uppercase;
    text-align: center;
  }

  th {
    font-size: ${fontSize06};
    font-weight: normal;
    padding: ${spacing03};
  }

  td {
    font-size: 10px;
    height: 18px;
  }
`;
